import React, { useState } from "react";
import { SuccessMessage } from "../common/APICommon";
import NoAccess from "./NoAccess";
import { getAll } from '@rusirunethmina/world-currencies-js';

const allCurrencies = getAll(); 

export default function Settings() {
  const [successMessage, setSuccessMessage] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState(() => {
    const saved = JSON.parse(localStorage.getItem("currency") || "{}");
    return saved.code || "USD"; // fallback to USD
  });
  

  const handleCurrencyChange = (event) => {
    setSelectedCurrency(event.target.value);
  };

  const saveChangesHandleClick = () => {
    const foundCurrency = allCurrencies.find(i => i.code === selectedCurrency);

    if (!foundCurrency) return;

    // Save to localStorage
    localStorage.setItem("currency", JSON.stringify(foundCurrency));
    setSuccessMessage("Saved successfully")
  };



//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasSettings) {
    return <NoAccess />;
  }
//#endregion





//#region UI
  return (
    <>
      <div className="p-6 bg-gray-100 min-h-screen shadow-lg">
        {/* Page Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-bold text-theme-color">{`Settings`}</h2>
        </div>

        <div className="mb-4 max-w-md">
          <label 
            htmlFor="currency-select" 
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Default Currency
          </label>
          <select
            id="currency-select"
            value={selectedCurrency}
            onChange={handleCurrencyChange}
            className="w-full p-2 border text-sm border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          >
            {/* 3. Map over the new array */}
            {allCurrencies.map((currency) => (
              // 'currency' is now an object like:
              // { code: "USD", name: "United States Dollar", symbol: "$" }
              <option key={currency.code} value={currency.code}>
                {currency.code} - {currency.name} ({currency.symbol})
              </option>
            ))}
          </select>
        </div>

        
          <button className="bg-theme-color text-white px-4 py-2 rounded-lg shadow hover:bg-theme-color-h transition duration-300"
            onClick={saveChangesHandleClick}
          >
            Save Changes
          </button>
      </div>
      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
      </div>
    </>
  );
//#endregion
}